import request from '../request';
import { seatAPI } from './urls';
import { config } from '../../utils/config';
import { identityAuth } from '../../auth/IdentityAuth';

const normalise = (assignedSeats) =>
  assignedSeats === null || assignedSeats === undefined ? null : assignedSeats;

// --- Limit (AssignedSeats): authored in Admin-Api ---------------------------------

// Sets a school's assigned seat limit. assignedSeats === null means unlimited.
// Rejections propagate (no swallow) so callers can report a failed save honestly.
const setSchoolLimit = (schoolId, assignedSeats) => {
  return request({
    url: seatAPI.setSchoolLimit(schoolId),
    method: 'PUT',
    data: { AssignedSeats: normalise(assignedSeats) },
  });
};

// Sets a group's assigned seat limit. assignedSeats === null means unlimited.
const setGroupLimit = (groupId, assignedSeats) => {
  return request({
    url: seatAPI.setGroupLimit(groupId),
    method: 'PUT',
    data: { AssignedSeats: normalise(assignedSeats) },
  });
};

// --- Usage (in-use count): owned + served by Identity, read directly --------------

// Best-effort: returns the in-use number, or null if Identity isn't reachable/configured
// (the card then shows the limit only, without the usage bar).
async function fetchUsage(path) {
  const baseUrl = config.IDENTITY_API_URL;
  if (!baseUrl) return null;
  const token = await identityAuth.getValidToken();
  if (!token) return null;
  try {
    const res = await fetch(`${baseUrl.replace(/\/$/, '')}/api/seats/usage/${path}`, {
      headers: { Accept: 'application/json', Authorization: `Bearer ${token}` },
    });
    if (!res.ok) return null;
    const data = await res.json();
    return typeof data?.inUse === 'number' ? data.inUse : null;
  } catch {
    return null;
  }
}

const getSchoolUsage = (schoolId) => fetchUsage(`school/${schoolId}`);
const getGroupUsage = (groupId) => fetchUsage(`group/${groupId}`);

const seatService = {
  setSchoolLimit,
  setGroupLimit,
  getSchoolUsage,
  getGroupUsage,
};

export default seatService;
